// Decides between the sign-in screen and the app.
//
// /auth/status answers without a 401, so a cold load of a signed-out browser
// does not fill the console with errors before showing the sign-in button. It
// also returns the role the server will actually enforce, which is what decides
// whether the admin screen is offered.

import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../api.js";
import { HexMark } from "../ui/icons.jsx";

const UserContext = createContext(null);

export const useUser = () => useContext(UserContext);
export const useIsAdmin = () => useContext(UserContext)?.role === "admin";

export const AuthGate = ({ children }) => {
  const [state, setState] = useState({ phase: "checking" });

  useEffect(() => {
    let cancelled = false;
    api
      .status()
      .then((res) => {
        if (cancelled) return;
        setState(res.signedIn ? { phase: "in", user: res.user } : { phase: "out" });
      })
      .catch((err) => !cancelled && setState({ phase: "error", error: err.message }));
    return () => {
      cancelled = true;
    };
  }, []);

  if (state.phase === "checking") {
    return (
      <div className="centre-screen">
        <p className="muted">Signing you in</p>
      </div>
    );
  }

  if (state.phase === "error") {
    return (
      <div className="centre-screen">
        <div className="card narrow">
          <h1>Cannot reach the server</h1>
          <p className="muted">{state.error}</p>
          <button className="btn" onClick={() => window.location.reload()}>
            Try again
          </button>
        </div>
      </div>
    );
  }

  if (state.phase === "out") {
    return (
      <div className="centre-screen">
        <div className="card narrow sign-in">
          <HexMark className="mark" />
          <h1>hivemind canvas</h1>
          <p className="muted">Sign in with your hivemind Google account.</p>
          <a
            className="btn primary"
            href={`/auth/login?next=${encodeURIComponent(window.location.pathname)}`}
          >
            Sign in with Google
          </a>
        </div>
      </div>
    );
  }

  return <UserContext.Provider value={state.user}>{children}</UserContext.Provider>;
};
